/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.Tag = (function () {

    function Tag () {

        this.serverTags = null;
        this.choiseTags = null;

        Monet.UI.Fields.Base.apply(this, arguments);

        this.createBaseStructure();

        this.createElement = function () {

            this.input = document.createElement('ul');
            this.input.className = 'tagit ui-widget ui-widget-content ui-corner-all';
            var descriptions = [];
            for (var x in this.serverTags) {
                if (this.serverTags.hasOwnProperty(x)) {
                    descriptions.push(this.serverTags[x].description);
                }
            }

            $(this.input).tagit({
                listTags: this.choiseTags,
                availableTags: descriptions,
                allowSpaces: true
            });


            this.rootEl.appendChild(this.input);

        };

        this.setServerTags = function (tags) {

            this.serverTags = tags;

        };

        this.getServerTags = function () {
            return this.serverTags;
        };

        this.addEventListener = function () {

            var that         = this,
                close        = $('.tagit-close'),
                closeOnClick = function (e) {

                    that.removeTag(e.target.parentElement.parentElement);

                };

            for (var i = 0; i < close.length; i++) {

                close[i].addEventListener("click", closeOnClick);

            }

        };

        this.setEntity = function (entity) {
            this.entity = entity;
        };

        var getHtmlTemplate = function (tags){
            var div = document.createElement("div");

            for(var i= 0, length= tags.length; i<length; i++) {
                var li        = document.createElement("li"),
                    spanLabel = document.createElement("span"),
                    spanLabel = document.createElement("span"),
                    a         = document.createElement("a"),
                    spanText  = document.createElement("span"),
                    spanIcon  = document.createElement("span"),
                    input     = document.createElement("input");

                li.className = "tagit-choice ui-widget-content ui-state-default ui-corner-all tagit-choice-editable";
                spanLabel.className = "tagit-label fromServer";
                a.className = "tagit-close";
                spanText.className = "text-icon";
                spanIcon.className = "ui-icon ui-icon-close";

                spanLabel.appendChild(document.createTextNode(tags[i].description));
                spanText.appendChild(document.createTextNode("x"));

                input.type = "hidden";
                input.value = tags[i].description;
                input.name = "tags";
                input.className = "tagit-hidden-field";

                a.appendChild(spanText);
                a.appendChild(spanIcon);

                li.appendChild(spanLabel);
                li.appendChild(a);
                li.appendChild(input);
                div.appendChild(li);
                li = null; spanLabel = null; a = null; spanText = null; spanIcon = null; input = null;
            }
            return div.innerHTML;
        };

        this.setValue = function (tags) {
            if (tags) {
                this.value = tags;
                this.choiseTags = tags;
                var htmlTemplate = '';

                htmlTemplate += getHtmlTemplate(tags);

                if (this.input) {
                    this.input.insertAdjacentHTML('afterbegin', htmlTemplate);
                    this.addEventListener();
                }
            }
        };

        this.getValue = function () {
            var list  = this.rootEl.querySelectorAll('.tagit .tagit-choice'),
                cacheTags = this.serverTags,
                listTags  = [],
                objToSend = {},
                tagValue;

            for (var i = 0; i < list.length; i++) {

                tagValue = list[i].children[0].innerHTML;

                if (tagValue !== '') {

                    objToSend = {
                        description: tagValue,
                        tagColor: "rgba(142,194,143, 0.55)",
                        tagType: this.entity.toUpperCase()
                    };

                    if (cacheTags) {

                        for (var j = 0; j < cacheTags.length; j++) {

                            if (cacheTags[j].description === tagValue) {
                                objToSend.id = cacheTags[j].id;
                                objToSend.tagColor = cacheTags[i].tagColor;
                                objToSend.tagType = cacheTags[i].tagType;
                                break;
                            }
                        }
                    }

                    listTags.push(objToSend);
                }
            }
            return listTags;
        };

        this.removeTag = function (tag) {

            tag = $(tag);

            tag.addClass('removed');
            var hide_args = ['blind', { direction: 'horizontal' }, 'fast'];

            hide_args.push(function () {
                tag.remove();
            });

            tag.fadeOut('fast').hide.apply(tag, hide_args).dequeue();

        };

        this.clear = function () {
            var tags = this.rootEl.querySelectorAll('li.tagit-choice.ui-widget-content.ui-state-default.ui-corner-all.tagit-choice-editable');
            var size = tags.length;
            for (var i = 0; i < size; i++) {
                tags[i].remove();
            }
        }.bind(this);

        this.retrieveTagsFromServer = function() {
            var ajax = new Monet.Ajax();
            ajax.url = 'Tag/restrictions?criteria={"filters":["*"]}';
            ajax.method = 'POST';
            ajax.data = '{"criteriaChain":[{"or":[{"attr":"tagType","eq":"' + this.entity.toUpperCase() + '"}]}]}';
            ajax.success = function (data) {
                if (data) {
                    this.serverTags = data;
                    this.addEventListener();
                }
            }.bind(this);

            ajax.error = function (responseText) {
                console.log('Error retrieving tags from server:', responseText);
            }.bind(this);

            ajax.send();
        };

        this.render = function () {
            this.retrieveTagsFromServer();
            this.createElement();

            if (this.value) {
                this.setValue(this.value);
            }

            return this.rootEl;

        };

    }

    return Tag;

}());